import { Injectable } from '@angular/core';
import { ViewType } from '@libs/common-components';
import { IGlobalLoader } from '../models/IGlobalLoader';

@Injectable({
  providedIn: 'root'
})
export class CampaignsGlobalLoaderService {
  private show = false;
  private title: string | null = null;
  private message: string | null = null;
  private view: ViewType | null = ViewType.empty;

  public showGlobalLoader(
    title: string,
    message: string,
    view: ViewType
  ): void {
    this.show = true;
    this.title = title;
    this.message = message;
    this.view = view;
  }

  public hideGlobalLoader(): void {
    this.show = false;
    this.title = null;
    this.message = null;
    this.view = ViewType.empty;
  }

  public get globalLoader(): IGlobalLoader {
    return {
      show: this.show,
      title: this.title,
      message: this.message,
      view: this.view
    };
  }
}
